import React, {Component} from 'react';

const pathPrefix = "/assets-2021/img/";
const newIconPath = pathPrefix + "icon-new-";

class Sites extends Component {
    render() {
        const {theme} = this.props
        return (
            <div id="sites">
                <a href="http://www.she.com/" title="she.com" className="site-item she" target="blank"
                   style={{display: (theme == 'she.com' ? 'none' : '')}}>
                    <img className="sites-icon" src={pathPrefix + "she-logo.png"} alt="she logo"/>
                </a>

                <a href="http://www.shemom.com/" title="shemom.com" className="site-item shemom"
                   target="blank" style={{display: (theme == 'shemom.com' ? 'none' : '')}}>
                    <img className="sites-icon" src={newIconPath + "shemom.svg"} alt="she mom logo"/>
                </a>

                <a href="http://brides.she.com/" title="shebrides" className="site-item brides"
                   target="blank" style={{display: (theme == 'brides.she.com' ? 'none' : '')}}>
                    <img className="sites-icon" src={newIconPath + "shebrides.svg"} alt="she brides logo"/>
                </a>

                {/*<a href="http://www.luxshery.com/" title="luxshery" className="site-item luxshery" target="blank" style={{ display:( theme == 'luxshery.com' ? 'none' : '') }}><span>luxshery</span></a>*/}
                {/*<a href="http://k.she.com/" title="k channel" className="site-item kchannel" target="blank" style={{ display:( theme == 'k.she.com' ? 'none' : '') }}><span>k channel</span></a>*/}

                <a href="http://critiques.she.com/" title="critiques" className="site-item critiques"
                   target="blank" style={{display: (theme == 'critiques.she.com' ? 'none' : '')}}>
                    <img className="sites-icon" src={newIconPath + "critiques.svg"} alt="she critiques logo"/>
                </a>

                {/*<a href="http://shop.she.com/" title="sheblog" className="site-item sheshop" target="blank" style={{ display:theme == 'shop.she.com' ? 'none' : '' }}><span>sheshops</span></a>*/}

                {/*<a href="http://community.she.com" title="messageboard" className="site-item messageboard"*/}
                {/*   target="blank" style={{display: (theme == 'community.she.com' ? 'none' : '')}}>*/}
                {/*    <img className="sites-icon" src={newIconPath + "messageboard.svg"} alt="message board logo"/>*/}
                {/*</a>*/}

                <a href="http://blog.she.com/" title="sheblog" className="site-item sheblog" target="blank"
                   style={{display: theme == 'blog.she.com' ? 'none' : ''}}>
                    <img className="sites-icon" src={newIconPath + "sheblog.svg"} alt="she blog logo"/>
                </a>

            </div>
        )
    }
}

export default Sites


// WEBPACK FOOTER //
// ./src/Sites.js